import { format, startOfMonth } from 'date-fns'

export const getCalendarDayKey = (date: Date) => format(date, 'yyyy-MM-dd')

export const getCalendarApiDayKey = (date: string) => date.slice(0, 10)

export const getMonthAnchorDate = (date: Date) => startOfMonth(date)
